export enum DeployEnvironment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  SANDBOXV2 = 'sandboxV2',
  PRODUCTION = 'production',
}

export type KudosEnv = {
  API_URL: `https://${string}`
  ROLLBAR_SDK_ID: string
  DEPLOY_ENVIRONMENT: DeployEnvironment
  WEB_PUSH_VAPID_PUBLIC_KEY: string
  TRANSIFEX_TOKEN: string | null
  GIPHY_API_KEY: string
  DEFAULT_DOMAIN: string
  MUI_PRO_KEY: string
  FROALA_ENTERPRISE_KEY: string
  MS_TEAMS_APP_STORE: string
  MAINTENANCE_STATUS_PAGE_URL?: string
  APP_VERSION: string
}

const localEnv: KudosEnv = {
  API_URL: 'https://api.kudosapp.dev',
  ROLLBAR_SDK_ID: 'dummy',
  DEPLOY_ENVIRONMENT: DeployEnvironment.DEVELOPMENT,
  WEB_PUSH_VAPID_PUBLIC_KEY:
    'BPmjX3blGUzOGv-ECzgbf4fmsal8mPT4uzWwYg-xy_vLR0zEWWB5a4mCfM4bTK4YQ0vLhDoQqS64YP92UIox1Ow',
  TRANSIFEX_TOKEN: '1/c007c8aa8b1ec099eed4b2fa675309096c71e3fe',
  GIPHY_API_KEY: '9jvcqKi1AIrPAgNIC1AlvXEV932r4AQe',
  DEFAULT_DOMAIN: 'https://my.kudosapp.dev',
  MUI_PRO_KEY:
    '26cf05534df89758968ab34b5556a591Tz0xMTQ5OTMsRT0xNzgzODE0NDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  FROALA_ENTERPRISE_KEY: 'aLF3c1A6B5D5E2F2B1F2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2A4D6B3D3E4E2A2==',
  MS_TEAMS_APP_STORE:
    'https://m365.cloud.microsoft/apps/?titleId=T_11abccfd-9bc1-f009-dce3-6dca1d0cbb5b&source=app-details-dialog-meta-os',
  APP_VERSION: '9bad4a7bbf487588de855e74b561c7f125543510',
}

const sandboxV2Env: KudosEnv = {
  API_URL: 'https://replace_api',
  ROLLBAR_SDK_ID: 'f7104f833fb649b39c741e4e8ba60a63',
  DEPLOY_ENVIRONMENT: DeployEnvironment.SANDBOXV2,
  WEB_PUSH_VAPID_PUBLIC_KEY:
    'BGPUKy4wC4w4jB2OryhQvQlMT9pJDnlrO3JCOHwAJ7wNgudTUa1JM2EnmRlSFkBH9F6l8tErLfKI539Zr47xSPE',
  TRANSIFEX_TOKEN: '1/c007c8aa8b1ec099eed4b2fa675309096c71e3fe',
  GIPHY_API_KEY: '9jvcqKi1AIrPAgNIC1AlvXEV932r4AQe',
  DEFAULT_DOMAIN: 'https://replace_url',
  MUI_PRO_KEY:
    'bb1aa625642ddea6b455de1657cdf031Tz05NDEzNyxFPTE3NTIzNDA5MjYwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
  FROALA_ENTERPRISE_KEY: 'aLF3c1A6B5D5E2F2B1F2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2A4D6B3D3E4E2A2==',
  MS_TEAMS_APP_STORE:
    'https://m365.cloud.microsoft/apps/?titleId=T_11abccfd-9bc1-f009-dce3-6dca1d0cbb5b&source=app-details-dialog-meta-os',
  APP_VERSION: '9bad4a7bbf487588de855e74b561c7f125543510',
}

const stagingEnv: KudosEnv = {
  API_URL: 'https://k-api.kudosnow-staging-k2.com',
  ROLLBAR_SDK_ID: 'f7104f833fb649b39c741e4e8ba60a63',
  DEPLOY_ENVIRONMENT: DeployEnvironment.STAGING,
  WEB_PUSH_VAPID_PUBLIC_KEY:
    'BGE88FHDlO69sZd74oznmlkMVbzjj3m7SDA5dOtJHtvItNf0yPRLZbtMELCWj1Mf9cSln4cSpDud01NwDrbMi1s',
  TRANSIFEX_TOKEN: '1/c007c8aa8b1ec099eed4b2fa675309096c71e3fe',
  GIPHY_API_KEY: '3bQe5vdPJ6910XcLN2uj18MmQ1DH1ttr',
  DEFAULT_DOMAIN: 'https://my.kudosnow-staging-k2.com',
  MUI_PRO_KEY:
    '26cf05534df89758968ab34b5556a591Tz0xMTQ5OTMsRT0xNzgzODE0NDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  FROALA_ENTERPRISE_KEY: 'aLF3c1A6B5D5E2F2B1F2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2A4D6B3D3E4E2A2==',
  MS_TEAMS_APP_STORE:
    'https://m365.cloud.microsoft/apps/?titleId=T_11abccfd-9bc1-f009-dce3-6dca1d0cbb5b&source=app-details-dialog-meta-os',
  APP_VERSION: '9bad4a7bbf487588de855e74b561c7f125543510',
}

const prodEnv: KudosEnv = {
  API_URL: 'https://k-api.kudos.com',
  ROLLBAR_SDK_ID: 'f7104f833fb649b39c741e4e8ba60a63',
  DEPLOY_ENVIRONMENT: DeployEnvironment.PRODUCTION,
  WEB_PUSH_VAPID_PUBLIC_KEY:
    'BNjyCqg37j_e94gBEqswFxwMjJ7M4saVRC6d3fa8BHLdFF_VqStK0yopPZtmPYMDmF8-qqu9uI62ipU4k8r3ZzI',
  TRANSIFEX_TOKEN: '1/c007c8aa8b1ec099eed4b2fa675309096c71e3fe',
  GIPHY_API_KEY: 'EspnLsorzUFYzXcKueH1qgKy7qBvlslF',
  DEFAULT_DOMAIN: 'https://my.kudos.com',
  MUI_PRO_KEY:
    '26cf05534df89758968ab34b5556a591Tz0xMTQ5OTMsRT0xNzgzODE0NDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  FROALA_ENTERPRISE_KEY: 'aLF3c1A6B5D5E2F2B1F2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2A4D6B3D3E4E2A2==',
  MS_TEAMS_APP_STORE:
    'https://m365.cloud.microsoft/apps/?titleId=T_11abccfd-9bc1-f009-dce3-6dca1d0cbb5b&source=app-details-dialog-meta-os',
  MAINTENANCE_STATUS_PAGE_URL: 'https://status.kudos.com/',
  APP_VERSION: '9bad4a7bbf487588de855e74b561c7f125543510',
}

const isLocal = (hostname: string) => /.*\.kudosapp\.dev$/.test(hostname)
const isSandboxV2 = (hostname: string) => /.*\.kudosnow-development-sandbox-v2\.com$/.test(hostname)
const isStaging = (hostname: string) => /.*\.kudosnow-staging-k2\.com$/.test(hostname)
const isProd = (hostname: string) => /.*\.kudos.com$/.test(hostname)

export const envConfig: KudosEnv = ((hostname: string): KudosEnv => {
  // ! please note, working within localhost is discouraged
  // ! ensure you have setup local development environment
  // ! to work with the proxy for {my.kudosapp.dev}

  if (isLocal(hostname)) {
    return localEnv
  } else if (isSandboxV2(hostname)) {
    return sandboxV2Env
  } else if (isStaging(hostname)) {
    return stagingEnv
  } else if (isProd(hostname)) {
    return prodEnv
  } else {
    // Default to local
    return localEnv
  }
})(window.location.hostname)
